import { config } from './environments';

export const { tokens } = config;

export const farmsConfig = config.farms.filter(farm => farm.excluded !== true);

export default config;
